import type { TreeNodeId } from '../Tree.types'

function generateRandomString(length: number) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length

  let result = ''

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return result
}

export interface CustomNode {
  id: number
  name: string
  parentId: TreeNodeId
  file: boolean
}

const root = {
  id: 1,
  name: 'Root Folder',
  parentId: null,
  file: false,
}

export function createMockData(amountOfNodes: number) {
  const ids: CustomNode['id'][] = [root.id]
  const mockData: CustomNode[] = [root]
  for (let i = 0, id = 2; i < amountOfNodes; i++, id++) {
    mockData.push({
      name: generateRandomString(5),
      id,
      file: false,
      parentId: ids[Math.floor(Math.random() * ids.length)],
    })
    ids.push(id)
  }
  const foldersIds = mockData.map((item) => item.parentId)
  const uniqueFolders = new Set(foldersIds)

  return mockData.map((item) =>
    uniqueFolders.has(item.id) ? item : { ...item, file: true }
  )
}
